import styled from 'styled-components/native'
import { FlatList } from 'react-native'

export const ModalWrapper = styled.View`
  width: 100%;
  height: 100%;
`

export const List = styled(FlatList)``
